import React, { useEffect, useState } from 'react'; 
import '../styles/Login.css';

const url = process.env.REACT_APP_FRONTEND_DOMAIN_NAME;
const client_Id = process.env.REACT_APP_COGNITO_CLIENT_ID;

const Login = () => {
    const [isRedirecting, setIsRedirecting] = useState(false);

    useEffect(() => {
        setIsRedirecting(true); // Start preloading screen
        setTimeout(() => {
            const cognitoDomain = "https://us-east-1rd5hzgep6.auth.us-east-1.amazoncognito.com";
            const loginUrl = `${cognitoDomain}/login?response_type=code&client_id=${client_Id}&redirect_uri=${encodeURIComponent(url)}&scope=email%20openid%20phone`;
            window.location.href = loginUrl;
        }, 0); // Delay to ensure smoother transition
    }, []);

    return (
        <div className={`auth-container ${isRedirecting ? 'fade-out' : ''}`}>
            <div className="preloader">
                <h2>Redirecting...</h2>
            </div>
        </div>
    );
};

export default Login;
